import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextArea = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input::placeholder": {
    fontWeight: "300",
    color: theme.palette.primary.main,
  },
  "& .MuiInputBase-root": { height: "160px" },
  textarea: {
    height: "100% !important",
    fontWeight: "300",
    color: theme.palette.primary.main,
  },
  "& textarea::-webkit-scrollbar": {
    width: "3px",
  },

  "& textarea::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
  },
}));

export default StyledTextArea;
